import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { FilterPills, DocList } from "@/pages/Quotes";
import { useQuick } from "@/components/Layout";
import { Button } from "@/components/ui/button";

export default function Jobs() {
  const quick = useQuick();
  const [f, setF] = useState("all");
  const { data: jobs = [], isLoading } = useQuery({ queryKey: ["jobs"], queryFn: () => api.get("/jobs").then((r) => r.data) });
  const list = jobs.filter((j) => f === "all" || (f === "imported" ? Boolean(j.imported_at) : j.status === f));
  return (
    <div data-testid="jobs-page">
      <PageHeader title="Jobs" subtitle={`${jobs.filter((j) => j.status !== "completed").length} open`} action={<Button onClick={() => quick.newJob()} className="btn-orange h-10" data-testid="jobs-new-button"><Plus size={16} /> New Job</Button>} />
      <FilterPills testId="jobs-filter" value={f} onChange={setF} options={[["all", "All"], ["scheduled", "Scheduled"], ["in_progress", "In Progress"], ["completed", "Completed"], ...(jobs.some((j) => j.imported_at) ? [["imported", "Imported"]] : [])]} />
      <DocList items={list} to="/jobs" testId="jobs-list" dateKey="scheduled_date" amountKey="quoted_amount" loading={isLoading} emptyTitle={f === "all" ? "No jobs yet" : "No jobs match this filter"} emptyHint={f === "all" ? "Convert an accepted quote or schedule a job directly." : undefined} sub={(j) => `${j.job_address || ""}${j.photos?.length ? ` | ${j.photos.length} photos` : ""}`} />
    </div>
  );
}
